<template>
    <div class="row offer-filter pad-top">
        <div class="col-md-12">
            <MultiSelect :disabled="disabled" :hide-selected="false" :multiple="true" :options="Storage.webFilter"
                         :placeholder="$t('filter.webmaster_grid')" :preserve-search="true"
                         :searchable="true" @input="dispatchInputAction" label="login"
                         ref="multiselect" track-by="login" v-model="Storage.webSelectedFilter">
                <template scope="props" slot="option">
                    <div class="option__desc">
            <span class="option__title">
             {{ props.option.login }}
            </span>
                    </div>
                </template>
            </MultiSelect>
        </div>
        <div class="col-md-12" style="padding-left: 25px;padding-top: 0.24rem">
            <c-switch :disabled="disabled" type="icon" v-bind="{on: '\uf00c', off: '\uf00d'}" v-model="Storage.byManualFilter" variant="info"/>
            {{ $t('filters.by_manual') }}
        </div>
    </div>
</template>

<script>
 import MultiSelect from 'vue-multiselect'
 import Storage from '../../api/Storage'
 import cSwitch from '../Switch'
 import API from '../../api/API'
 import Helper from '../../api/Helper'

export default {
   name: 'ByWmFilterAll',
   components: {
     cSwitch,
     MultiSelect
   },
   props: {
     disabled: {
       type: Boolean,
       required: true
     }
   },
   mounted () {
     this.$root.$on('filters_reset_all', () => {
       this.reset()
     })
     this.$refs.multiselect.$on('select', function () {
       this.search = ''
     })
   },
   data () {
     return {
       Storage: Storage
     }
   },
   methods: {
     dispatchInputAction () {
       this.$root.$emit('country_selected')
     }
   }
 }
</script>

<style>
    .pad-top{
        padding-top:5px;
    }
</style>



// WEBPACK FOOTER //
// ByWmFilterAll.vue?66b86338